import { FeatureHelperService } from './../../../_helpers/feature-helper/feature-helper.service';
import { TutorReportsHelperService } from '../../../_helpers/tutor-reports-helper/tutor-reports-helper.service';
import { Component, OnInit, OnChanges, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PlacementService, ActionService } from "../../../_services/index";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../../_helpers/custom-validators';

import { MatDialog } from '@angular/material/dialog';
import { SubmissionHistoryRecords } from '../../../shared/submission-history-records';
import { SuccessModalHelperService } from '../../../_helpers/success-modal-helper/success-modal-helper.service';
import { BaseComponent } from '../../../base.component';
import { Subscription, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PlacementData } from '../../../_models';
import { MediaChange } from '@ngbracket/ngx-layout';
import { DropdownDialogComponent } from '../../../shared/dropdown-list-dialog';
import { ActionData } from '../../../_models/actions';
import { ThemeService } from '../../../_helpers/theming-engine/theme.service';
import { LearningBandTableModalComponent } from '../../learning-band-table-modal/learning-band-table-modal.component';
import { ErrorModalHelperService } from '../../../_helpers/error-modal-helper/error-modal-helper.service';
import { ProgressReportInfo, StudentOutcome } from '../../../_models';
@Component({
    templateUrl: 'tutor-reports.outcome-detail.component.html',
    selector: 'student-outcome-detail',
    standalone: false
})

export class TutorReportsOutcomeDetailComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  public placementData: PlacementData;
  private unsubscribe: Subject<void> = new Subject<void>();

  @Input() studentIdForLinkAssessment: number;
  @Output() onDataSaved: EventEmitter<any> = new EventEmitter<any>();
  @Output() onClosed: EventEmitter<any> = new EventEmitter<any>();

  model: any = {};
  errors: any = {};
  frmStudentOutcomes: UntypedFormGroup;
  current: number = 1;
  action: string;
  grades: any = [];
  keyStages: any = [];
  mindate: Date = new Date(new Date().setDate(new Date().getDate() - 180));
  maxdate: Date = new Date(new Date().setDate(new Date().getDate() + 1));
  showPanel: boolean = false;
  baseline: any = {};
  baselineDateError: string = '';
  submissionData: boolean = false;
  watcher: Subscription;

  public formSavedSubmitted: boolean = false;

  public hasStaffSavePermissions: boolean = false;
  public hasManagerSavePermissions: boolean = false;
  public hasEditPermissions: boolean = false;

  public hasApprovePermissions: boolean = false;
  public hasRejectPermissions: boolean = false;

  public headerSubText: string = "";

  public groupStudentFullName: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private placementService: PlacementService,
    private actionService: ActionService,
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private successModalHelper: SuccessModalHelperService,
    public tutorReportsHelperService: TutorReportsHelperService,
    private featureHelperService: FeatureHelperService,
    public themeService: ThemeService,
    private errorModalHelper: ErrorModalHelperService,
  ) {
    super();
    this.watcher = this.media.asObservable().subscribe((changes: MediaChange[]) => { const change = changes[0]; if (!change) return;
      this.loadContent(change.mqAlias);
    });

    this.tutorReportsHelperService.placementData$
      .pipe(
        filter((d): d is PlacementData => d != null),
        takeUntil(this.unsubscribe)
      )
      .subscribe(pd => this.placementData = pd);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges() {
    if (this.tutorReportsHelperService.progressReport && this.tutorReportsHelperService.progressReport.currentReport) {
      this.model = this.tutorReportsHelperService.progressReport.currentReport
    }
    this.populateForm(this.model);
    this.showPanel = true;
    this.initialize();

    if (this.tutorReportsHelperService.baseline != null) {
      this.baseline = this.tutorReportsHelperService.baseline;
    }
  }

  ngOnInit() {
    this.initialize();
    this.placementService.getBaseline(this.tutorReportsHelperService.commonData.placementId, this.tutorReportsHelperService.commonData.groupStudentId, this.tutorReportsHelperService.commonData.isStudentGroup).subscribe(result => {
      this.baseline = result;
    });

    this.headerSubText = this.themeService.siteContent.progressReportText;

    if (this.placementData.aPorSP && this.placementData.aPorSP.toLowerCase() == "ntp") {
      this.headerSubText = this.themeService.siteContent.progressReportTextNtp;
    }

    this.createForm();
    
    this.keyStages = this.tutorReportsHelperService.keyStages;
    this.grades = this.tutorReportsHelperService.targetGrades;

    
    if (this.tutorReportsHelperService.progressReport && this.tutorReportsHelperService.progressReport.currentReport) {
      this.model = this.tutorReportsHelperService.progressReport.currentReport
    }
    this.populateForm(this.model);
  }

  public setFocus() {
    document.getElementById("Close").focus();
  }

  initialize() {
    if (!this.model) {
      this.model = {
        currentReport: {
          outcomeDate: '',
          id: 0,
          submitted: 0,
          target: ''
        }
      }
    }
  }

  createForm() {
    this.mindate = new Date(this.tutorReportsHelperService.commonData.placementStartDate);
    this.maxdate = new Date(this.tutorReportsHelperService.commonData.placementEndDate);

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (today.valueOf() < this.maxdate.valueOf()) {
      this.maxdate = today;
    }
    if (today.valueOf() < this.mindate.valueOf()) {
      this.maxdate = this.mindate;
    }
    
    this.mindate.setHours(0, 0, 0 ,0);
    this.maxdate.setHours(0, 0, 0 ,0);

    this.frmStudentOutcomes = this.formBuilder.group({
      outcomeDate: [null, Validators.compose([
        Validators.required,
        this.dateLessThan('outcomeDate', { DateCannotBeEarlierThanBaselineDate: true }),
        CustomValidators.DateRangeValidator('outcomeDate', this.mindate, this.maxdate),
      ])],
      learningBand: [null, Validators.compose([
        Validators.required, Validators.min(1)
      ])],
      keyStage: [null, Validators.compose([
        Validators.required, Validators.min(1)
      ])],
      comments: [null, [Validators.maxLength(1024)]],
      target: [null, [Validators.maxLength(1024)]],
      learnerComments: [null, [Validators.maxLength(1024)]],
      id: [null],
      assessmentScorePercentage: [null, [Validators.required, Validators.min(0), Validators.max(100)]],
      assessmentId: [null, null],
      assessmentDate: [null, null],
      //studentAchievedProgress: [null, null]
    });
    
  }

  submitOutcome() {
    this.validate(true);
    var formModel = this.populateModel();
    if (this.frmStudentOutcomes.invalid) {
      this.errorModalHelper.show("Please complete all sections before submitting", {isValidationError: true});
      return;
    }
    formModel.statusId = 2;
    formModel.submitted = true;
    let studentId = this.tutorReportsHelperService.commonData.groupStudentId ? this.tutorReportsHelperService.commonData.groupStudentId : this.studentIdForLinkAssessment;
    formModel.studentId = studentId;

    let actionData: ActionData = {
      placementId: this.tutorReportsHelperService.commonData.placementId,
      actionTypeId: 2,
      rowId: 0,
      appUserId: this.tutorReportsHelperService.commonData.applicationUserId,
      tutorId: this.placementData.tutorId,
      section: 'PR'
    };

    this.placementService.submitStudentOutcome(formModel, actionData).subscribe(data => {
      this.scrollBeforeClose();
      setTimeout(() => {
        this.successModalHelper.show('Progress Report submitted');
        this.model.submitted = true;
        this.showPanel = false;
        formModel.id = data;

        //this.createAction(formModel, 2);

        let emitValue: string = this.enableViewEditButtons();
        this.onDataSaved.emit(emitValue === "View");
        this.close();
      }, 500);
    },
      error => {
        this.errorModalHelper.show(error.message, error);
      })
  }

  saveOutcome() {
    this.validate(false);
    if (this.frmStudentOutcomes.invalid) {
      this.errorModalHelper.show("Please complete all sections before saving", {isValidationError: true});
      return;
    }
    var formModel = this.populateModel();
    formModel.statusId = 1;
    let studentId = this.tutorReportsHelperService.commonData.groupStudentId ? this.tutorReportsHelperService.commonData.groupStudentId : this.studentIdForLinkAssessment;
    formModel.studentId = studentId;
    this.placementService.saveStudentOutcome(formModel).subscribe(data => {
      this.scrollBeforeClose();
      setTimeout(() => {
        this.successModalHelper.show('Progress Report details saved');
        this.showPanel = false;
        this.onDataSaved.emit(true);
        this.close();
      }, 500);
    },
      error => {
        this.errorModalHelper.show(error.message, error);
      })
  }

  populateModel() {
    var formModel = this.frmStudentOutcomes.value;
    if (formModel.comments && formModel.comments.trim().length > 0) {
      let comment = formModel.comments.trim();
      formModel.comments = comment.charAt(0) === ':' ? comment.substring(1).trim() : comment;
      formModel.comments = this.htmlToPlaintext(formModel.comments);
    }

    if (formModel.target && formModel.target.trim().length > 0) {
      let target = formModel.target.trim();
      formModel.target = target.charAt(0) === ':' ? target.substring(1).trim() : target;
      formModel.target = this.htmlToPlaintext(formModel.target);
    }

    if (formModel.learnerComments && formModel.learnerComments.trim().length > 0) {
      let learnerComments = formModel.learnerComments.trim();
      formModel.learnerComments = learnerComments.charAt(0) === ':' ? learnerComments.substring(1).trim() : learnerComments;
      formModel.learnerComments = this.htmlToPlaintext(formModel.learnerComments);
    }

    formModel.outcomeDate = new Date(this.setDate(formModel.outcomeDate));
    formModel.placementId = this.tutorReportsHelperService.commonData.placementId;
    formModel.applicationUserId = this.tutorReportsHelperService.commonData.applicationUserId;
    formModel.id = formModel.id == null ? 0 : formModel.id;

    /* if (this.frmStudentOutcomes.get("keyStage").value == -1) {
       formModel.keyStage = null;
     }
     if (this.frmStudentOutcomes.get("learningBand").value == -1) {
       formModel.learningBand = null;
     }*/
    formModel.keyStage = this.getFormValueforDropdowns(this.keyStages, "keyStage", false);
    formModel.learningBand = this.getFormValueforDropdowns(this.grades, "learningBand", true);

    return formModel;
  }

  validate(enableSubmitValidation) {
    this.formSavedSubmitted = true;
    this.mindate = new Date(this.tutorReportsHelperService.commonData.placementStartDate);
    this.maxdate = new Date(this.tutorReportsHelperService.commonData.placementEndDate);

    let maxDateDiff = ((this.maxdate.valueOf() - new Date().valueOf()));
    var maxDateDiffInDays = Math.ceil(maxDateDiff / (1000 * 3600 * 24));

    if (maxDateDiffInDays > 7) {
      let newMaxDate = new Date();
      newMaxDate.setDate(newMaxDate.getDate() + 7);
      this.maxdate = newMaxDate;
    }

    this.mindate.setHours(0, 0, 0 ,0);
    this.maxdate.setHours(0, 0, 0 ,0);

    this.frmStudentOutcomes.get('outcomeDate').setValidators(Validators.compose([
      Validators.required,
      this.dateLessThan('outcomeDate', { DateCannotBeEarlierThanBaselineDate: true }),
      CustomValidators.DateRangeValidator('outcomeDate', this.mindate, this.maxdate),
    ]));
    this.frmStudentOutcomes.get('outcomeDate').updateValueAndValidity();
    
    this.frmStudentOutcomes.get('assessmentScorePercentage').setValidators(null);
    //this.frmStudentOutcomes.get('studentAchievedProgress').setValidators(null);

    if(enableSubmitValidation) {
      this.frmStudentOutcomes.get('assessmentScorePercentage').setValidators([Validators.min(0), Validators.max(100)]);
      //this.frmStudentOutcomes.get('studentAchievedProgress').setValidators([Validators.required]);
    }

    this.frmStudentOutcomes.get('assessmentScorePercentage').updateValueAndValidity();
    //this.frmStudentOutcomes.get('studentAchievedProgress').updateValueAndValidity();
    this.frmStudentOutcomes.updateValueAndValidity();
  }

  dateLessThan(to: string, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var datefld = new Date(control.value);
      if (!control.value) {
        return null;
      }
      if (this.baseline !== null && this.baseline.baselineDate !== null) {
        if (datefld < new Date(this.baseline.baselineDate)) {
          this.baselineDateError = "Date cannot be earlier than individual learning plan date " + this.datePipe.transform(this.baseline.baselineDate, 'dd/MM/yyyy');
          return error;//{ key: 'DateCannotBeEarlierThanBaselineDate'};
        }
      }
      else {
        this.baselineDateError = 'Individual Learning Plan section should be completed, and the date should be later than or equal to the Individual Learning Plan date';
        return error;
      }
      return null;
    }
  }

  populateForm(data: StudentOutcome) {
    if (this.frmStudentOutcomes == null) {
      return;
    }
    if (data == null) {
      return;
    }

    if (this.media.isActive('xs')) {
      this.setDropdownValues(this.keyStages, "keyStage", false);
      this.setDropdownValues(this.grades, "learningBand", true);
    }

    let requiredPermissions = new Array<string>();
    requiredPermissions.push("ProgressReportsSave", "TutorReportsSave", "ProgressReportsEdit", "ProgressReportsApprove", "ProgressReportsReject");
    let permissionsResult = this.featureHelperService.checkFeaturePermissions(requiredPermissions);
    this.hasStaffSavePermissions = permissionsResult.filter(p => p.feature === "ProgressReportsSave")[0].enabled;
    this.hasManagerSavePermissions = permissionsResult.filter(p => p.feature === "TutorReportsSave")[0].enabled;
    this.hasEditPermissions = permissionsResult.filter(p => p.feature === "ProgressReportsEdit")[0].enabled;

    this.hasApprovePermissions = permissionsResult.filter(p => p.feature === "ProgressReportsApprove")[0].enabled;
    this.hasRejectPermissions = permissionsResult.filter(p => p.feature === "ProgressReportsReject")[0].enabled;

    this.action = data.id !== null && data.id > 0 ? 'Review' : 'Add';
    this.frmStudentOutcomes.get('outcomeDate').setValue(data.outcomeDate);
    this.frmStudentOutcomes.get('learningBand').setValue(data.learningBand);
    this.frmStudentOutcomes.get('keyStage').setValue(data.keyStage);
    this.frmStudentOutcomes.get('comments').setValue(data.comments);
    this.frmStudentOutcomes.get('learnerComments').setValue(data.learnerComments);
    this.frmStudentOutcomes.get('target').setValue(data.target);
    this.frmStudentOutcomes.get('id').setValue(data.id);
    this.frmStudentOutcomes.get('assessmentScorePercentage').setValue(data.assessmentScorePercentage);
    this.frmStudentOutcomes.get('assessmentId').setValue(data.assessmentId);
    this.frmStudentOutcomes.get('assessmentDate').setValue(data.assessmentCaptureDate);

    if (!data.submitted && !data.approved) {
      this.frmStudentOutcomes.enable();
    } else if (this.hasEditPermissions && !data.approved) {
        this.frmStudentOutcomes.enable();
    } else {
      this.frmStudentOutcomes.disable();
    }

    if (data.approved) {
      this.action = 'Approved';
    }
    this.getHistoryData();

  }

  public approveData(event) {
    if (this.frmStudentOutcomes == null) {
      return;
    }
    var formModel = this.populateModel();
    formModel.statusId = 3;
    if (formModel.id === 0) {
      this.errorModalHelper.show("Submit the page", {isValidationError: true});
    } else {
      this.placementService.ApproveOutcome(formModel).subscribe(data => {
        this.scrollBeforeClose();
        setTimeout(() => {
          this.successModalHelper.show("Progress Report is approved");
          this.deleteAction(formModel, 2);
          this.onDataSaved.emit(true);
          this.close();
        }, 500);
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        })
    }
  }

  public rejectData(data) {
    var formModel = this.populateModel();
    formModel.statusId = 4;
    if (formModel.id === 0) {
      this.errorModalHelper.show("Submit the page", {isValidationError: true});
    } else {
      var rejectData = {
        rowId: formModel.id,
        comment: data
      };

      this.placementService.RejectOutcome(rejectData).subscribe(data => {
        this.scrollBeforeClose();
        setTimeout(() => {
          this.successModalHelper.show("Progress Report is rejected");
          this.model.submitted = false;
          this.createAction(formModel, 6);
          this.onDataSaved.emit(true);
          this.close();
        }, 500);
      },
        error => {
          this.errorModalHelper.show(error.message, error);
        })
    }
  }

  public close() {
    //this.onDataSaved.emit(true);
    this.onClosed.emit(true);
  }

  private deleteAction(model, actionType) {
    var actionData = {
      placementId: this.tutorReportsHelperService.commonData.placementId,
      actionTypeId: actionType,
      rowId: model.id,
      appUserId: this.tutorReportsHelperService.commonData.applicationUserId,
      id: this.tutorReportsHelperService.commonData.actionId,
      tutorId: this.placementData.tutorId,
      section: 'PR'
    };
    this.actionService.deleteAction(actionData).subscribe(action => {

    });
  }

  private createAction(model, actiontype) {

    var actionData = {
      placementId: this.tutorReportsHelperService.commonData.placementId,
      actionTypeId: actiontype,
      rowId: model.id,
      appUserId: this.tutorReportsHelperService.commonData.applicationUserId,
      tutorId: this.placementData.tutorId,
      section: 'PR'
    };
    this.actionService.createAction(actionData).subscribe(action => {

    });
  }

  private htmlToPlaintext(text) {
    return text ? String(text).replace(/<[^>]+>/gm, '').replace('&nbsp;', ' ') : '';
  }

  setDate(date) {
    var d = new Date(date);
    return d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  }

  private openDialog() {
    const dialogRef = this.dialog.open(SubmissionHistoryRecords, {
      data: { rowId: this.frmStudentOutcomes.value.id, reportSection: 'PR' },
      panelClass: 'my-dialog'
    });
  }

  private getHistoryData() {
    var subParam = { rowId: this.frmStudentOutcomes.value.id, reportSection: 'PR' };
    this.placementService.GetSubmissionHistory(subParam).subscribe((result: any) => {
      this.submissionData = result.length > 0;
      
    });
  }

  public enableViewEditButtons() {
    var element = this.model;
    let permissionRequirements = new Array<string>();
    permissionRequirements.push("TutorReportsGridItemEdit", "TutorReportsGridItemView");
    let permissionsResult = this.featureHelperService.checkFeaturePermissions(permissionRequirements);

    if (!element.approved && !element.submitted) {
      return "Edit";
    } else if (permissionsResult.filter(p => p.feature === "TutorReportsGridItemEdit")[0].enabled && element.statusDescription != "Approved") {
      return "Edit";
    }
    return 'View';
  }

  loadContent(mQuery) {
    if (mQuery === 'xs') {
      this.setDropdownValues(this.keyStages, "keyStage", false);
      this.setDropdownValues(this.grades, "learningBand", true);
    }
    else {
      if (this.frmStudentOutcomes && this.frmStudentOutcomes.value) {
        var data = this.frmStudentOutcomes.value;
        this.setDropdownValuesforLargeDevices(this.grades, "learningBand", true)
        this.setDropdownValuesforLargeDevices(this.keyStages, "keyStage", false)
      }
    }
  }

  setDropdownValuesforLargeDevices(listData, controlName, secondValue) {
    var ctrlValue = this.frmStudentOutcomes.get(controlName).value;
    var value = ctrlValue;
    if (ctrlValue != null && isNaN(ctrlValue)) {
      if (secondValue) {
        value = listData.find(x => ctrlValue.includes(x.description)).id;
      }
      else {
        value = listData.find(x => x.description === ctrlValue).id;
      }
      if (value === -1) {
        this.frmStudentOutcomes.get(controlName).setValue(null);
      }
    }
    this.frmStudentOutcomes.get(controlName).setValue(value);
  }

  setDropdownValues(listData, controlName, secondValue) {
    var value = listData.find(x => x.id === this.frmStudentOutcomes.get(controlName).value);
    if (value != null && value.description !== null) {
      var strValue = secondValue ? value.code + "  " + value.description : value.description;
      this.frmStudentOutcomes.get(controlName).setValue(strValue);
    }
  }

  getFormValueforDropdowns(listData, controlName, secondValue) {
    var ctrlValue = this.frmStudentOutcomes.get(controlName).value;
    var value = ctrlValue;
    if (ctrlValue != null && isNaN(ctrlValue)) {
      if (secondValue) {
        value = listData.find(x => x.code + "  " + x.description === ctrlValue).id;
      }
      else {
        value = listData.find(x => x.description === ctrlValue).id;
      }
      if (value === -1) {
        this.frmStudentOutcomes.get(controlName).setValue(null);
        return null;
      }
    }
    else if (ctrlValue === -1) {
      return null;
    }

    return value;
  }

  public openReferenceTable(): void {
    const dialogRef = this.dialog.open(LearningBandTableModalComponent, 
      {
      panelClass: 'my-dialog'
    });
  }

  public parseAssessmentScore($e: any) {
    // This will prevent: "e", "=", ",", "+" "-", "-", "." // Covers minus on number pad also.
    // removed binding to - and .  109, 189, 190
    if ([69, 187, 188, 107].includes($e.keyCode)) {
      $e.preventDefault();
    }

    if (!/^[-+]?(\d+)?([.]?\d{0,1})?$/g.test($e.target.value)) {
      // block unless its the backspace
      if (![8].includes($e.keyCode)) {
        $e.preventDefault();
      }
    }
  }

  private openDropdownDialog(dataList, controlName, controlHeader, value, secondValue) {
    const dialogRef = this.dialog.open(DropdownDialogComponent, {
      panelClass: 'dropdown-dialog-container',
      data: { header: controlHeader, items: dataList, selected: value, secondValue: secondValue }
    });

    dialogRef.componentInstance.onValueSelected.subscribe((data) => {
      if (secondValue) {
        data = this.grades.find(x => x.description === data).code + "  " + data;
      }
      this.frmStudentOutcomes.get(controlName).setValue(data);
      dialogRef.close();
    })
  }
  
  private scrollBeforeClose(): void {
    // window.scroll({ top: 0, behavior: 'smooth' });
    const element = document.getElementById("student-outcome-header");
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
